const { GET_PAYMENT_IPG_SUCCESS, GET_PAYMENT_IPG_FAIL, PAYMENT_MELLI_RESET, GET_PAYMENT_IPG } = require("./actionTypes");

const INIT_STATE ={
    paymentMelliUrl:'',
    error:'',
    success:'',
    loading:false,
}


const reducer = (state=INIT_STATE,action)=>{
    switch (action.type) {
        case GET_PAYMENT_IPG:
            return{
                ...state,
                loading:true,
            }
        case GET_PAYMENT_IPG_SUCCESS:
            return{
                ...state,
                paymentMelliUrl:action.payload,
                loading:false,
                success:"لینک با موفقیت انجام شد"
            }
        case GET_PAYMENT_IPG_FAIL:
            return{
                ...state,
                loading:false,
                error:action.payload
            }



        case PAYMENT_MELLI_RESET:
            return{
                ...state,
                error:null,
                success:null,
                loading:false
            }
        default:
            return state
    
    }
}

export default reducer